import type { TeamData, TeamTableColumns } from '@library/types/teams';
import type { TableColumn } from '@library/types/utils';

export const TEAMS_TABLE_HEADER: Array<TableColumn<TeamTableColumns>> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[6%] px-3'
  },

  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'abbreviation',
    essential: true,
    label: 'Abbreviation',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'market',
    essential: true,
    label: 'Market',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'primaryColor',
    essential: true,
    label: 'Primary',
    sortEnabled: false,
    width: 'w-[7%] px-3'
  },
  {
    column: 'secondaryColor',
    essential: true,
    label: 'Secondary',
    sortEnabled: false,
    width: 'w-[7%] px-3'
  },
  {
    column: 'tertiaryColor',
    essential: true,
    label: 'Tertiary',
    sortEnabled: false,
    width: 'w-[8%] px-3'
  },
  {
    column: 'league',
    essential: true,
    label: 'League',
    sortEnabled: false,
    width: 'w-[7%] px-3'
  },
  {
    column: 'ppid',
    essential: true,
    label: 'PPID',
    sortEnabled: false,
    width: 'w-[6%] px-3'
  },
  {
    column: 'newPlayers',
    essential: true,
    label: 'New Players',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'homeGames',
    essential: true,
    label: 'Home Games',
    sortEnabled: false,
    width: 'w-[11%] px-3'
  },
  {
    column: 'awayGames',
    essential: true,
    label: 'Away Games',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  }
];

export const DEFAULT_TEAM_DATA: TeamData = {
  id: '',
  name: '',
  abbreviation: '',
  market: '',
  primaryColor: '',
  secondaryColor: '',
  tertiaryColor: '',
  newPlayers: [],
  homeGames: [],
  awayGames: [],
  league: '',
  type: '',
  ppid: ''
};
